import { render, staticRenderFns } from "./UniversalSearch.vue?vue&type=template&id=53879cc2&scoped=true&"
import script from "./UniversalSearch.vue?vue&type=script&lang=js&"
export * from "./UniversalSearch.vue?vue&type=script&lang=js&"
import style0 from "./UniversalSearch.vue?vue&type=style&index=0&id=53879cc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53879cc2",
  null
  
)

export default component.exports